export const BusinessStageMap: { [index: number]: string } = {
	0: 'I have an idea for a business',
	1: 'My business has started with a little sales',
	2: 'My business is stable and I pay myself',
}

export const OfferingsMap: { [index: string]: string } = {
	'Products': 'Products',
	'Services': 'Services',
	'Both': 'Products & Services',
}

export type BusinessStageType = '0' | '1' | '2';

export type BusinessTypeType = 'For Profit' | 'Non-Profit';

export type OfferingsType = 'Products' | 'Services' | 'Both';